import ModalCaratulaRti from '../ModalCaratulaRti';
import ModalCaratulaArt from '../ModalCaratulaArt';
import ModalCaratulaPnc from '../ModalCaratulaPnc';
import ModalCaratulaAmparoPnc from '../ModalCaratulaAmparoPnc';
import ModalCaratulaAmparoLey16986 from '../ModalCaratulaAmparoLey16986';
import ModalCaratulaPuam from '../ModalCaratulaPuam';
import ModalCaratulaPlanPago from '../ModalCaratulaPlanPago';
import ModalCaratulaReajuste from '../ModalCaratulaReajuste';
import ModalCaratulaJubilacion from '../ModalCaratulaJubilacion';
import ModalCaratulaPension from '../ModalCaratulaPension';
import ModalCaratulaReajustePension from '../ModalCaratulaReajustePension';
import ModalCaratulaDeclaratoria from '../ModalCaratulaDeclaratoria';
import ModalCaratulaGanancias from '../ModalCaratulaGanancias';
import ModalCaratulaReconocimiento from '../ModalCaratulaReconocimiento';
import {
    obtenerDatosCaratulaRti, generarCaratulaRtiTramite,
    obtenerDatosCaratulaArt, generarCaratulaArtTramite,
    obtenerDatosCaratulaPnc, generarCaratulaPncTramite,
    obtenerDatosCaratulaAmparoPnc, generarCaratulaAmparoPncTramite,
    obtenerDatosCaratulaPuam, generarCaratulaPuamTramite,
    obtenerDatosCaratulaPlanPago, generarCaratulaPlanPagoTramite,
    obtenerDatosCaratulaReajuste, generarCaratulaReajusteTramite,
    obtenerDatosCaratulaJubilacion, generarCaratulaJubilacionTramite,
    obtenerDatosCaratulaPension, generarCaratulaPensionTramite,
    obtenerDatosCaratulaReajustePension, generarCaratulaReajustePensionTramite,
    obtenerDatosCaratulaDeclaratoria, generarCaratulaDeclaratoriaTramite,
    obtenerDatosCaratulaGanancias, generarCaratulaGananciasTramite,
    obtenerDatosCaratulaReconocimiento, generarCaratulaReconocimientoTramite,
} from '../../../services/caratulaService';

/** Nombre con el que se descarga y se adjunta el .docx, salvo que el módulo lo redefina. */
const nombrePorPrefijo = (prefijo) => (datos, idTramite) =>
    `${prefijo} - ${datos.apellidoNombre || idTramite}.docx`;

/**
 * Qué carátula emite cada tipo de trámite. Las claves son las MISMAS que usa
 * TRAMITES_CONFIG en pages/Recepcion/VistaDetalladaAtencion.js, así que las dos pantallas
 * resuelven por la misma clave (normalizada con normalizarTipoTramite) — EXCEPTO
 * REAJUSTE_PENSION, que no tiene tipoTramite propio (es tramite_reajuste.beneficio = PENSION
 * dentro del módulo Reajuste, ver esa entrada más abajo). PENSION sí es un tipoTramite real
 * desde V185 y coincide con la clave, pero el registro también se usa desde trámites GENERICO
 * viejos que colgaban la carátula de Pensión sin tener ese tipoTramite (ver
 * VistaDetalladaTramiteGenerico.js).
 *
 * Cada entrada dice qué modal dibujar, contra qué par de endpoints hablar y cómo se llama el
 * archivo. `variantes` lo declaran Jubilación, Pensión y Reajuste de Pensión: es lo que hace
 * que el botón abra primero un menú en vez de ir directo al modal.
 */
const caratulaRegistry = {
    RTI: {
        etiqueta: 'RTI',
        urlBase: 'rti',
        modal: ModalCaratulaRti,
        obtenerDatos: obtenerDatosCaratulaRti,
        generar: generarCaratulaRtiTramite,
        nombreArchivo: nombrePorPrefijo('CARATULA RTI'),
        mensajeDescarga: 'Descargando la Carátula RTI',
    },
    ART: {
        etiqueta: 'ART',
        urlBase: 'art',
        modal: ModalCaratulaArt,
        obtenerDatos: obtenerDatosCaratulaArt,
        generar: generarCaratulaArtTramite,
        nombreArchivo: nombrePorPrefijo('CARATULA ART'),
        mensajeDescarga: 'Descargando la Carátula ART',
    },
    PNC: {
        etiqueta: 'PNC',
        urlBase: 'pnc',
        modal: ModalCaratulaPnc,
        obtenerDatos: obtenerDatosCaratulaPnc,
        generar: generarCaratulaPncTramite,
        nombreArchivo: nombrePorPrefijo('CARATULA PNC'),
        mensajeDescarga: 'Descargando la Carátula PNC',
    },
    AMPARO_PNC: {
        etiqueta: 'Amparo PNC',
        urlBase: 'amparo-pnc',
        modal: ModalCaratulaAmparoPnc,
        obtenerDatos: obtenerDatosCaratulaAmparoPnc,
        generar: generarCaratulaAmparoPncTramite,
        nombreArchivo: nombrePorPrefijo('CARATULA AMPARO PNC'),
        mensajeDescarga: 'Descargando la Carátula de Amparo PNC',
    },
    // Variante de Amparo PNC (V256). Con trámite habla con los endpoints de Amparo PNC: el backend
    // elige la plantilla por el tipo del trámite. Sin trámite usa su propio segmento (urlBase).
    AMPARO_LEY_16986: {
        etiqueta: 'Amparo Ley 16.986',
        urlBase: 'amparo-ley-16986',
        modal: ModalCaratulaAmparoLey16986,
        obtenerDatos: obtenerDatosCaratulaAmparoPnc,
        generar: generarCaratulaAmparoPncTramite,
        nombreArchivo: nombrePorPrefijo('CARATULA AMPARO LEY 16.986'),
        mensajeDescarga: 'Descargando la Carátula de Amparo Ley 16.986',
    },
    PUAM: {
        etiqueta: 'PUAM',
        urlBase: 'puam',
        modal: ModalCaratulaPuam,
        obtenerDatos: obtenerDatosCaratulaPuam,
        generar: generarCaratulaPuamTramite,
        nombreArchivo: nombrePorPrefijo('CARATULA PUAM'),
        mensajeDescarga: 'Descargando la Carátula de PUAM',
    },
    PLAN_PAGO: {
        etiqueta: 'Plan de Pago',
        urlBase: 'plan-pago',
        modal: ModalCaratulaPlanPago,
        obtenerDatos: obtenerDatosCaratulaPlanPago,
        generar: generarCaratulaPlanPagoTramite,
        nombreArchivo: nombrePorPrefijo('CARATULA PLAN DE PAGO'),
        mensajeDescarga: 'Descargando la Carátula de Plan de Pago',
    },
    REAJUSTE: {
        etiqueta: 'Reajuste',
        urlBase: 'reajuste',
        modal: ModalCaratulaReajuste,
        obtenerDatos: obtenerDatosCaratulaReajuste,
        generar: generarCaratulaReajusteTramite,
        nombreArchivo: (datos, idTramite) => {
            const sufijos = {
                PENSION_BADARO: 'PENSION BADARO',
                PENSION_REPARACION_HISTORICA: 'PENSION REPARACION HISTORICA',
            };
            const sufijo = sufijos[datos.variante];
            return `CARATULA REAJUSTE${sufijo ? ' ' + sufijo : ''} - ${datos.apellidoNombre || idTramite}.docx`;
        },
        mensajeDescarga: 'Descargando la Carátula de Reajuste',
        // Si el beneficio es PENSION, suman los datos del causante (autocompletados desde
        // tramite.causanteXxx) y usan las plantillas de Reajuste de Pensión — mismo papel que
        // REAJUSTE_PENSION, pero acá SÍ hay tramite_reajuste de dónde traer el causante.
        variantes: [
            {
                value: 'REAJUSTE',
                titulo: 'Reajuste',
                detalle: 'Badaro o Reparación Histórica según el tipo de reajuste del trámite',
            },
            {
                value: 'PENSION_BADARO',
                titulo: 'Reajuste Pensión Badaro',
                detalle: 'Suma los datos del causante, conceptos del reclamo, índice puro e IPC',
            },
            {
                value: 'PENSION_REPARACION_HISTORICA',
                titulo: 'Reajuste Pensión Reparación Histórica',
                detalle: 'Suma los datos del causante y la ley; un solo renglón de monto',
            },
        ],
    },
    JUBILACION: {
        etiqueta: 'Jubilación',
        urlBase: 'jubilacion',
        modal: ModalCaratulaJubilacion,
        obtenerDatos: obtenerDatosCaratulaJubilacion,
        generar: generarCaratulaJubilacionTramite,
        nombreArchivo: (datos, idTramite) => {
            // Mismos sufijos que VARIANTES en CaratulaJubilacionDocumentoService.
            const sufijos = {
                LEY_27675: '27675',
                CAJA_PROVINCIA: 'CAJA DE LA PROVINCIA',
                CUIDADO_HIJOS: 'CUIDADO DE HIJOS',
            };
            const sufijo = sufijos[datos.variante] || '24476';
            return `CARATULA JUBILACION ${sufijo} - ${datos.apellidoNombre || idTramite}.docx`;
        },
        mensajeDescarga: 'Descargando la Carátula de Jubilación',
        // Las dos carátulas del módulo sirven para cualquier trámite, así que la elección es
        // del operador y no se deriva de ningún campo (a diferencia de Reajuste, donde el
        // backend la saca de tipoReajuste). Los value coinciden con las constantes VARIANTE_*
        // de CaratulaJubilacionDocumentoService.
        variantes: [
            {
                value: 'LEY_24476',
                titulo: 'Carátula 24476',
                detalle: 'La simple, sin evaluación médica',
            },
            {
                value: 'LEY_27675',
                titulo: 'Carátula 27675',
                detalle: 'Con patología, regularidad y junta médica',
            },
            {
                value: 'CAJA_PROVINCIA',
                titulo: 'Caja de la Provincia',
                detalle: 'RECO, datos de CIDI, moratoria, banco y subsidio',
            },
            {
                value: 'CUIDADO_HIJOS',
                titulo: 'Cuidado de Hijos',
                detalle: 'Ley por hijos: cantidad, AUH/CUD, actas e iniciar',
            },
        ],
    },
    // Desde V185 PENSION es un tipoTramite real y esta clave coincide con TRAMITES_CONFIG
    // (VistaDetalladaAtencion.js) como el resto. Los trámites GENERICO viejos que ya tenían
    // carátula de Pensión colgada (decisión de producto: no se migran) la siguen generando
    // desde una rama explícita en VistaDetalladaTramiteGenerico.js, que también usa esta clave.
    PENSION: {
        etiqueta: 'Pensión',
        urlBase: 'pension',
        modal: ModalCaratulaPension,
        obtenerDatos: obtenerDatosCaratulaPension,
        generar: generarCaratulaPensionTramite,
        nombreArchivo: (datos, idTramite) => {
            const sufijos = { HIJO_DISCAPACIDAD: 'HIJO CON DISCAPACIDAD', DERIVADA: 'DERIVADA' };
            const sufijo = sufijos[datos.variante] || 'DIRECTA';
            return `CARATULA PENSION ${sufijo} - ${datos.apellidoNombre || idTramite}.docx`;
        },
        mensajeDescarga: 'Descargando la Carátula de Pensión',
        variantes: [
            {
                value: 'DIRECTA',
                titulo: 'Pensión Directa',
                detalle: 'Causante en actividad; domicilio del titular y del causante',
            },
            {
                value: 'DERIVADA',
                titulo: 'Pensión Derivada',
                detalle: 'Causante jubilado; suma N° de Beneficio',
            },
            {
                value: 'HIJO_DISCAPACIDAD',
                titulo: 'Pensión por hijo con discapacidad',
                detalle: 'Suma N° de Beneficio; un solo renglón de domicilio',
            },
        ],
    },
    REAJUSTE_PENSION: {
        etiqueta: 'Reajuste de Pensión',
        urlBase: 'reajuste-pension',
        modal: ModalCaratulaReajustePension,
        obtenerDatos: obtenerDatosCaratulaReajustePension,
        generar: generarCaratulaReajustePensionTramite,
        nombreArchivo: (datos, idTramite) => {
            const sufijo = datos.variante === 'REPARACION_HISTORICA' ? 'REPARACION HISTORICA' : 'BADARO';
            return `CARATULA REAJUSTE PENSION ${sufijo} - ${datos.apellidoNombre || idTramite}.docx`;
        },
        mensajeDescarga: 'Descargando la Carátula de Reajuste de Pensión',
        variantes: [
            {
                value: 'BADARO',
                titulo: 'Caso Badaro',
                detalle: 'Conceptos del reclamo, Índice puro e IPC',
            },
            {
                value: 'REPARACION_HISTORICA',
                titulo: 'Reparación Histórica',
                detalle: 'Suma Ley; un solo renglón de monto',
            },
        ],
    },
    DECLARATORIA_HEREDEROS: {
        etiqueta: 'Declaratoria de Herederos',
        urlBase: 'declaratoria',
        modal: ModalCaratulaDeclaratoria,
        obtenerDatos: obtenerDatosCaratulaDeclaratoria,
        generar: generarCaratulaDeclaratoriaTramite,
        nombreArchivo: (datos, idTramite) =>
            `CARATULA DECLARATORIA DE HEREDEROS - ${datos.apellidoNombreTitular || idTramite}.docx`,
        mensajeDescarga: 'Descargando la Carátula de Declaratoria de Herederos',
    },
    GANANCIAS: {
        etiqueta: 'Impuesto a las Ganancias',
        urlBase: 'ganancias',
        modal: ModalCaratulaGanancias,
        obtenerDatos: obtenerDatosCaratulaGanancias,
        generar: generarCaratulaGananciasTramite,
        nombreArchivo: nombrePorPrefijo('CARATULA IMPUESTO A LAS GANANCIAS'),
        mensajeDescarga: 'Descargando la Carátula de Impuesto a las Ganancias',
    },
    RECONOCIMIENTO: {
        etiqueta: 'Reconocimiento de Servicios',
        urlBase: 'reconocimiento',
        modal: ModalCaratulaReconocimiento,
        obtenerDatos: obtenerDatosCaratulaReconocimiento,
        generar: generarCaratulaReconocimientoTramite,
        nombreArchivo: nombrePorPrefijo('CARATULA RECONOCIMIENTO DE SERVICIOS'),
        mensajeDescarga: 'Descargando la Carátula de Reconocimiento de Servicios',
    },
};

export default caratulaRegistry;
